<template>
  <div>
    <section class="rf-hero">
      <img :src="`${ASSETS}/hero.jpg`" alt="Lago y montañas en el sur de Chile">
      <div class="rf-hero-capa">
        <h1>Un Refugio de paz al fin del Mundo</h1>
        <p>Cambia el ruido por silencio y el estrés por naturaleza</p>
        <p>Vive del agua pura, tierra propia y libertad real.</p>
        <a href="/landing-refugios/proyectos" class="rf-btn rf-btn--vidrio">Conoce los proyectos</a>
      </div>
    </section>

    <section class="rf-seccion rf-seccion--centro">
      <h2 class="rf-titulo-serif">Bienestar Real</h2>
      <p class="rf-lead">
        No es solo un refugio, sino un lugar para vivir mejor: aire puro, silencio, naturaleza y
        desconexión del estrés urbano.
      </p>
      <p class="rf-lead">
        No es huir, es elegir vivir mejor. En la zona Austral de Chile despiertas con aire puro,
        rodeado de bosques y agua viva, donde el silencio reemplaza al ruido y el tiempo vuelve a
        ser tuyo. Da el paso: cambia el ritmo de la ciudad por la calma profunda de la naturaleza.
      </p>
      <img
        class="rf-ilustracion"
        :src="`${ASSETS}/illustration-bienestar.png`"
        alt="Ilustración de paisaje austral con ciervos y montañas"
      >
    </section>

    <section class="rf-seccion rf-seccion--centro rf-seccion--clara">
      <span class="rf-eyebrow">Proyectos Destacados</span>
      <h2 class="rf-titulo-serif">Refugios Australes</h2>
      <p class="rf-lead" style="color: var(--teal)">Parcelas de Conservación estratégicamente ubicadas en Chile.</p>
      <p class="rf-lead">
        El lugar más seguro no tiene muros de concreto, tiene miles de kilómetros de océano de por
        medio. En el sur de Chile, la paz no es un lujo, es la consecuencia geográfica de estar en el
        fin del mundo.
      </p>
      <div class="rf-iconos">
        <div v-for="i in iconos" :key="i.img" class="rf-icono">
          <img :src="`${ASSETS}/${i.img}`" :alt="i.texto.join(' ')">
          <span>{{ i.texto[0] }}<br>{{ i.texto[1] }}</span>
        </div>
      </div>
    </section>

    <p v-if="error" class="rf-estado rf-estado--error">{{ error }}</p>
    <div v-else-if="destacados.length" class="rf-anchas">
      <rf-tarjeta v-for="p in destacados" :key="p.id" :p="p" ancha />
    </div>
    <div class="rf-ver-todos">
      <a href="/landing-refugios/proyectos" class="rf-btn">Ver todos los proyectos</a>
    </div>

    <section class="rf-pilares">
      <div>
        <h3>Distancia Estratégica</h3>
        <p>
          Ubicación privilegiada en el hemisferio sur, alejada de los focos de conflicto geopolítico
          y tensiones de Europa.
        </p>
      </div>
      <div>
        <h3>Soberanía Alimentaria</h3>
        <p>
          Tierras con aptitud agrícola y acceso a agua pura, permitiéndote producir tu propio
          alimento en un entorno sin contaminación.
        </p>
      </div>
      <div>
        <h3>Kit de Vivienda Eficiente</h3>
        <p>
          Solución habitacional de construcción rápida y sencilla, diseñada para integrarse al
          paisaje sin complicaciones logísticas.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import RfTarjeta from './RfTarjeta.vue';
import { ASSETS } from './formato';
import { listarProyectos } from '@/services/refugiosApi';

const ICONOS = [
  { img: 'icon-distancia.png', texto: ['Distancia', 'Estratégica'] },
  { img: 'icon-construccion.png', texto: ['Construcción', 'Simple (en kit)'] },
  { img: 'icon-tierra.png', texto: ['Tierra fértil y', 'agricultura'] },
  { img: 'icon-autosustentabilidad.png', texto: ['Autosustentabilidad', 'integral'] },
  { img: 'icon-seguridad.png', texto: ['Seguridad', 'pasiva'] },
];

export default {
  name: 'RfInicio',
  components: { RfTarjeta },
  data() {
    return { ASSETS, iconos: ICONOS, destacados: [], error: '' };
  },
  async mounted() {
    try {
      this.destacados = await listarProyectos({ destacados: true });
    } catch (e) {
      this.error = 'No se pudieron cargar los proyectos destacados.';
    }
  },
};
</script>
